import { FormField, FormError } from './utils';
import { luhnCheck } from './input';

export function detectCreditCardInformation(f: FormField, validationType: string): FormError {
  let value = f.field.value;

  /* This regex matches the following:
   * - Any number from 13 to 19 digits long
   * - Any string with:
   *   - 4 numbers
   *   - 1 symbol/space
   *   - 4-6 numbers
   *   - 1 symbol/space
   *   - 4-5 numbers
   *   - 1 symbol/space
   *   - 4-5 numbers
   * - OR any string with:
   *   - 4 numbers
   *   - 1 symbol/space
   *   - 4-6 numbers
   *   - 1 symbol/space
   *   - 4-5 numbers
   *
   *  All of the above conditions are evaluated on the value of the field by our custom Luhn algorithm,
   *  and if found to be a "valid" credit card number, is returned to the Form Validation Component
   *  without the number included anymore.
   */
  let matches = value.matchAll(
    /(\d{13,19}|\d{4}([^a-zA-Z]|\s)\d{4,6}([^a-zA-Z]|\s)\d{4,5}([^a-zA-Z]|\s)\d{4,5}|\d{4}([^a-zA-Z]|\s)\d{4,6}([^a-zA-Z]|\s)\d{4,5})/g
  );
  let results: string[] = [];

  if (matches) {
    Array.from(matches).forEach((match) => {
      // Clean the matched string and validate with Luhn algorithm
      const cleanNumber = match[0].replace(/\D/g, '');
      if (luhnCheck(cleanNumber)) {
        results.push(match[0]);
      }
    });
  }

  const formError = {
    type: validationType,
    message:
      '<b>PII Warning: Credit card number found and removed.</b><br>If you feel that this was not PII (such as a number similar to a credit card), please inform #production-support.',
  };

  // If our validation finds a result (or results), remove them from the field value.
  if (results) {
    results.forEach((result) => {
      f.field.value = f.field.value.replace(result, '');
    });
  }

  return results.length > 0 ? formError : null;
}
